export enum MedicationImportStatus {
  IMPORTED = 'imported',
  LOCAL = 'local',
}
